"use client";

import { SafeHydrate } from "@/SafeHydrate";
import React, { useEffect, useState } from "react";
import { Calendar, Globe } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function DonChuyCuidamosALosQueMasQuieres() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const titleWords = ["World", "Immigration"];
  return <section data-section-id="222686" id="orizzonti-senza-confini" className="dark relative overflow-hidden bg-[#091221] bg-fixed py-16 md:py-24 lg:py-32">
      <style jsx global>{`
        @keyframes drift {
          0%, 100% { transform: translateY(0) scale(1); }
          50% { transform: translateY(-20px) scale(1.05); }
        }
        @keyframes pulse-glow {
          0%, 100% { transform: scale(1); opacity: 1; }
          50% { transform: scale(1.05); opacity: 0.8; }
        }
        @keyframes blob-float {
          0% { transform: translate(0, 0) scale(1); }
          33% { transform: translate(30px, -50px) scale(1.1); }
          66% { transform: translate(-20px, 20px) scale(0.9); }
          100% { transform: translate(0, 0) scale(1); }
        }
      `}</style>

      <div className="pointer-events-none absolute inset-0 z-0 overflow-hidden">
        <div className="absolute -right-[10%] -top-[10%] h-[60%] w-[50%] rounded-lg bg-primary/10 blur-[80px] animate-[blob-float_7s_infinite_ease-in-out]" style={{
        opacity: 0.12
      }} />
        <div className="absolute -bottom-[10%] -left-[10%] h-[50%] w-[40%] rounded-lg bg-secondary/10 blur-[80px] animate-[blob-float_8s_infinite_ease-in-out_reverse]" style={{
        opacity: 0.08
      }} />
        <div className="absolute top-1/4 left-1/3 h-[30%] w-[30%] rounded-lg bg-primary/5 blur-[80px] animate-[blob-float_6s_infinite_ease-in-out]" style={{
        opacity: 0.1
      }} />
      </div>

      <div className="container relative z-10 mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-12 lg:gap-16">
          
          <div ref={textRef} className={`flex flex-col items-start space-y-8 lg:col-span-7 transition-all duration-1000 ease-out ${isTextVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`}>
            <div className="space-y-4">
              <span className={`inline-block bg-secondary/10 px-4 py-1.5 text-sm font-medium text-white font-mono tracking-widest uppercase transition-all duration-700 delay-100 ${isTextVisible ? 'translate-y-0 opacity-100' : 'translate-y-4 opacity-0'}`}>
                World Immigration di Delgado
              </span>
              <h1 className="font-default text-4xl font-bold tracking-tighter text-white sm:text-5xl md:text-6xl lg:text-[4rem] lg:leading-[1.1] flex flex-wrap gap-x-4">
                {titleWords.map((word, i) => <span key={i} data-index={i} className={`inline-block transition-all duration-[300ms] ease-out ${isTextVisible ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'}`} style={{
                transitionDelay: `${300 + i * 100}ms`
              }}>
                    {word}
                  </span>)}
              </h1>
              
              <div className={`inline-flex items-center gap-2 rounded-lg border border-[#00F5FF]/30 bg-[#00F5FF]/10 px-3 py-1 text-xs font-bold text-[#FFC829] shadow-[var(--glow-cyan)] animate-[pulse-glow_2s_infinite_ease-in-out] transition-all duration-700 delay-400 ${isTextVisible ? 'opacity-100' : 'opacity-0'}`}>
                <Globe className="h-3 w-3" />
                TECH 2026
              </div>
            </div>
            
            <p className={`max-w-2xl text-lg text-white md:text-xl leading-relaxed font-default transition-all duration-700 delay-500 ${isTextVisible ? 'translate-y-0 opacity-100' : 'translate-y-4 opacity-0'}`}>
              Visti e Mobilità Internazionale
            </p>
            
            <div className={`flex flex-col sm:flex-row gap-4 pt-4 transition-all duration-700 delay-700 ${isTextVisible ? 'translate-y-0 opacity-100' : 'translate-y-4 opacity-0'}`}>
              <Button asChild size="lg" className="h-14 px-8 text-base bg-[#FFC829] text-black hover:bg-[#FFC829]/90 hover:shadow-[0_0_20px_rgba(255,200,41,0.4)] hover:scale-105 transition-all duration-300 border-none">
                <Link href="https://calendly.com/worldimmigration-ana_delgado" newTab>
                  <SafeHydrate><Calendar className="mr-2 h-5 w-5" /></SafeHydrate>
                  Prenota Consulenza
                </Link>
              </Button>

              <Button asChild size="lg" className="h-14 px-8 text-base bg-[#FFC829] text-black hover:bg-[#FFC829]/90 hover:shadow-[0_0_20px_rgba(255,200,41,0.4)] hover:scale-105 transition-all duration-300 border-none">
                <Link to="https://worldimmigration.it/richiedi-la-tua-pratica-online/" newTab>
                  La tua Pratica ONLINE
                </Link>
              </Button>
            </div>
          </div>

          <div ref={imageRef} className={`relative lg:col-span-5 transition-all duration-1000 delay-200 ease-out ${isImageVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
            <div className="relative mx-auto max-w-[840px] lg:max-w-none">
              <div className="relative aspect-[3/4] w-full overflow-hidden border border-primary/20 shadow-2xl rounded-lg">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663124/img/global_mobility_executive.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663124/img/global_mobility_executive.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663124/img/global_mobility_executive.png-wvc-sizes" alt="Rappresentazione astratta della mobilità globale e visti" loading="lazy" className="h-full w-full object-cover transition-transform duration-700 hover:scale-105 opacity-80" />
                <div className="absolute inset-0 ring-1 ring-inset ring-primary/30 bg-gradient-to-t from-background/80 to-transparent" />
              </div>

              <div className="absolute -bottom-8 -left-8 md:-bottom-12 md:-left-12 h-40 w-40 md:h-56 md:w-56 overflow-hidden border-[1px] border-primary bg-background/80 backdrop-blur-md shadow-2xl rounded-lg animate-[drift_4s_ease-in-out_infinite] flex items-center justify-center p-4">
                <Link to="/">
                  <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663124/img/logo nuovo..png" alt="World Immigration Logo" className="h-24 w-auto opacity-80" loading="lazy" />
                </Link>
              </div>
              
              <div className="absolute -right-6 -top-6 -z-10 h-32 w-32 bg-[radial-gradient(var(--color-primary)_1px,transparent_1px)] [background-size:16px_16px] opacity-30" />
            </div>
          </div>

        </div>
      </div>
    </section>;
}